import React, { Component } from "react";
import "../../sidebar/style.css";
import axios from "axios";
import { Button } from "shards-react";
import "react-notifications/lib/notifications.css";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { CBP, ImpactFestival } from "../../components/certificateFormFields";
import { EVENT_TYPES, EVENT_DISPLAY_NAMES } from "../../constants";

class CBPListUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: null,
      desc: null,
      upload: false,
      term: null,
      eventEndDate: null,
      eventStartDate: null,
      className: null,
      cbpID: null,
      errors: null,
      eventType: EVENT_TYPES.CBP,
    };
  }

  fetchCBPData = (id) => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/cbp/${id}`, {
        headers: { "x-access-token": localStorage.getItem("jwtToken") },
      })
      .then((res) => {
        const {
          name,
          description,
          term,
          _id,
          className,
          eventStartDate,
          eventEndDate,
        } = res.data.metadata;
        this.setState({
          name,
          desc: description,
          term,
          cbpID: _id,
          className,
          eventStartDate: new Date(eventStartDate).toISOString().split("T")[0],
          eventEndDate: new Date(eventEndDate).toISOString().split("T")[0],
        });
      })
      .catch((err) => {
        console.error(err);
        this.createNotification("error");
      });
  };

  fileSelectedHandler = (event) => {
    this.setState({
      selectedFile: event.target.files[0],
    });
  };

  createNotification = (type, message) => {
    switch (type) {
      case "success":
        NotificationManager.success(
          "Success message",
          "Successfully Posted",
          1000
        );
        this.UpdateChecker();
        break;
      case "error":
        NotificationManager.error(message, "Error message", 1000);
        break;
      default:
        break;
    }
  };

  UpdateChecker = () => {
    if (this.state.upload === true) {
      this.props.history.push("/cbp-list");
    }
  };

  onSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("file", this.state.selectedFile);
    formData.append("name", this.state.name);
    formData.append("desc", this.state.desc);
    formData.append("term", this.state.term);
    formData.append("className", this.state.className);
    formData.append("eventType", this.state.eventType);
    formData.append("eventStartDate", this.state.eventStartDate);
    formData.append("eventEndDate", this.state.eventEndDate);

    let url = `${process.env.REACT_APP_API_URL}/cbp`;
    let method = "POST";

    if (this.state.cbpID) {
      url = `${process.env.REACT_APP_API_URL}/cbp/${this.state.cbpID}`;
      method = "PUT";
    }

    fetch(url, {
      method: method,
      headers: {
        "x-access-token": localStorage.getItem("jwtToken"),
      },
      body: formData,
    })
      .then((res) => {
        if (res.status === 200) {
          this.setState({
            upload: true,
          });
          this.createNotification("success");
        }
        if (res.status === 422) {
          res.json().then((data) => {
            this.setState({ errors: data.error });
          });
        }
      })
      .catch((error) => {
        this.createNotification("error", error);
      });
  };

  getCsvPath = () => {
    const { eventType } = this.state;

    if (eventType === EVENT_TYPES.CBP) {
      return "/assets/Sample.csv";
    }

    return "/assets/impact_festival_participation.csv";
  };

  componentDidMount() {
    const { match } = this.props;
    if (match.params.cbpID) {
      this.fetchCBPData(match.params.cbpID);
    }
  }

  render() {
    const { errors, name, desc, eventType, cbpID } = this.state;
    const resolvedEventType = eventType || EVENT_TYPES.CBP;
    return (
      <React.Fragment>
        <NotificationContainer />
        <section className="hero-section pt-50 pb-50">
          <div className="container">
            <div className="col-md-12 col-lg-12 ">
              <h1 className="event-title">Upload CBP List</h1>
              {this.state.errors && this.state.errors.length > 0 && (
                <div className="error-section shadow-lg mb-4">
                  <div className="card-body px-md-5 py-2">
                    <h5 className="text-center text-danger">
                      Errors Found In Sheet
                    </h5>
                    <ul>
                      {this.state.errors.map((error, index) => (
                        <li key={index} className="text text-danger">
                          {error.message}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
              <div className="card login-signup-card shadow-lg mb-0">
                <div className="card-body px-md-5 py-5">
                  <form onSubmit={this.onSubmit}>
                    <div className="row">
                      <div className="col-md-6">
                        <label className="pb-1">Name</label>
                        <input
                          onChange={(event) =>
                            this.setState({ name: event.target.value })
                          }
                          value={this.state.name || ""}
                          type="text"
                          name="name"
                          className="form-control"
                          placeholder="Please Enter The Event Name"
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <div className="">
                          <label className="pb-1 mr-2">Upload CSV*</label>
                          <a
                            href="/assets/Sample.csv"
                            className="underline-link"
                          >
                            Here is a sample file
                          </a>
                        </div>
                        <div className="input-group input-group-merge">
                          <input
                            onChange={this.fileSelectedHandler}
                            type="file"
                            name="file"
                            className="form-control"
                            placeholder=""
                            required
                          />
                          <Button type="submit">Upload List</Button>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <label className="pb-1">Description</label>
                        <input
                          onChange={(event) => {
                            this.setState({ desc: event.target.value });
                          }}
                          type="text"
                          value={this.state.desc || ""}
                          name="desc"
                          className="form-control"
                          placeholder=""
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="pb-1">Select Event Type</label>
                        <select
                          onChange={(event) =>
                            this.setState({
                              eventType: event.target.value,
                            })
                          }
                          value={this.state.eventType || EVENT_TYPES.CBP}
                          name="eventType"
                          className="form-select form-control"
                          required
                        >
                          <option value="" disabled>
                            Select an event type
                          </option>
                          {Object.entries(EVENT_TYPES).map(([key, value]) => (
                            <option key={value} value={value}>
                              {EVENT_DISPLAY_NAMES[value]}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="d-flex align-items-center my-4">
                      <div className="flex-grow-1 border-top"></div>
                      <h5 className="mx-3 txt mb-0">Certificate Fields</h5>
                      <div className="flex-grow-1 border-top"></div>
                    </div>
                    {resolvedEventType === EVENT_TYPES.CBP ? (
                      <CBP
                        state={this.state}
                        isEdit={cbpID}
                        setState={(newState) => this.setState(newState)}
                      />
                    ) : (
                      <ImpactFestival
                        state={this.state}
                        isEdit={cbpID}
                        setState={(newState) => this.setState(newState)}
                      />
                    )}
                    <Button type="submit" value="submit" className="submit-btn">
                      Submit
                    </Button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default CBPListUpload;
